// src/context/SocketContext.js
import React, { createContext, useContext, useEffect, useRef, useState, useCallback } from 'react';
import { io } from 'socket.io-client';
import { useAuth } from './AuthContext';

const SocketContext = createContext(null);

const SOCKET_URL = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api')
  .replace('/api', '');

export function SocketProvider({ children }) {
  const { user } = useAuth();
  const socketRef   = useRef(null);
  const [onlineCount,   setOnlineCount]   = useState(1);
  const [leaderboard,   setLeaderboard]   = useState([]);
  const [chatMessages,  setChatMessages]  = useState([
    { username: 'System', avatar: '🤖', text: 'Welcome to Codrion! 🎮' }
  ]);

  useEffect(() => {
    if (!user) return;
    const socket = io(SOCKET_URL, { transports: ['websocket'], reconnectionAttempts: 5 });
    socketRef.current = socket;

    socket.on('connect',            () => socket.emit('user:join', user.id || user._id));
    socket.on('leaderboard:updated', d  => setLeaderboard(d));
    socket.on('presence:update',    d  => setOnlineCount(d.onlineCount || 1));
    socket.on('chat:message',       msg => setChatMessages(p => [...p.slice(-49), msg]));

    return () => { socket.disconnect(); socketRef.current = null; };
  }, [user]);

  const sendChat = useCallback((text) => {
    if (!socketRef.current || !user) return;
    socketRef.current.emit('chat:message', {
      userId: user.id || user._id,
      username: user.username,
      avatar: user.avatar,
      text,
    });
  }, [user]);

  const sendWorldPosition = useCallback((position) => {
    if (!socketRef.current || !user) return;
    socketRef.current.emit('world:position', {
      userId: user.id || user._id,
      username: user.username,
      position,
    });
  }, [user]);

  const refreshLeaderboard = useCallback(() => {
    if (socketRef.current) socketRef.current.emit('leaderboard:refresh');
  }, []);

  return (
    <SocketContext.Provider value={{ onlineCount, leaderboard, chatMessages,
                                     sendChat, sendWorldPosition, refreshLeaderboard }}>
      {children}
    </SocketContext.Provider>
  );
}

export const useSocket = () => useContext(SocketContext);
